import { axios } from "../config";

function getReportCardExaminationList(params) {
  return axios.get("/api/v1/exams/list", { params });
}
function publishAllReportCardResult(payload) {
  return axios.post("/api/v1/exams/publish/all", payload);
}

function getFormlistingData(params) {
  return axios.get("/api/v1/exams/class", { params });
}

function getStudentListReportList(params) {
  return axios.get("/api/v1/exams/class-students", { params });
}

function publishReportData(data) {
  return axios.post("/api/v1/exams/publish", data);
}

function getTeacherListData() {
  return axios.get("/api/v1/teachers");
}

function notifyTeacherReportCard(data) {
  return axios.post("/api/v1/exams/notify-teacher", data);
}

function getStudentDetails(params) {
  return axios.get("/api/v1/exams/report-view", { params });
}

function getAcademicPerformance(params) {
  return axios.get("/api/v1/students/summary-report-card", { params });
}

function getReportCardDetails(params) {
  return axios.get("/api/v1/students/details-for-report", { params });
}

function getReportCardPdf(params) {
  return axios.get("/api/v1/students/report-card/download", {
    params,
  });
}

function getReportCardList(params) {
  return axios.get("/api/v1/exams", {
    params,
  });
}

function getEcdClasses(params) {
  return axios.get("/api/v1/ecd-assessment/classes-by-academic-year", {
    params,
  });
}

function getEcdStudents(params) {
  return axios.get("/api/v1/ecd-assessment/students", {
    params,
  });
}

function getEcdStudentDetails(params) {
  return axios.get("/api/v1/ecd-assessment/report-view", { params });
}

function publishEcdReportCard(data) {
  return axios.post("/api/v1/ecd-assessment/publish-reports", data);
}

function getEcdReportCardPdf(params) {
  return axios.get("/api/v1/ecd-assessment/download-report", {
    params,
  });
}

function publishAllEcdReport(payload) {
  return axios.post("/api/v1/ecd-assessment/publish-all", payload);
}

function ecdNotifyTeacher(data) {
  return axios.post("/api/v1/ecd-assessment/notify-teacher", data);
}

export {
  getReportCardExaminationList,
  getFormlistingData,
  getStudentListReportList,
  publishReportData,
  getTeacherListData,
  notifyTeacherReportCard,
  getStudentDetails,
  publishAllReportCardResult,
  getAcademicPerformance,
  getReportCardDetails,
  getReportCardPdf,
  getReportCardList,
  getEcdClasses,
  getEcdStudents,
  getEcdStudentDetails,
  publishEcdReportCard,
  getEcdReportCardPdf,
  publishAllEcdReport,
  ecdNotifyTeacher,
};
